import { autobind } from 'core-decorators';
import React from 'react';
import _ from 'underscore';
import { Modal } from 'app/blocks/blocks';
import { Button, PrimaryButton } from 'app/blocks/buttons/buttons';
import DialogMessage from 'app/blocks/dialog/dialog__message';
import OrdersRowAddress from 'app/pages/orders/row/address';
import RadioButton from 'app/ui/form/RadioButton';

const profileAddresses = [
    { id: 'correspondenceAddress', name: 'Contact Address' },
    { id: 'billingAddress', name: 'Billing Address' },
    { id: 'shippingAddress', name: 'Shipping Address' },
];

@autobind
class OrdersDialogProfileAddresses extends React.PureComponent {
    constructor(props) {
        super(props);

        const selected = {};

        _.every(profileAddresses, address => {
            if (this.isShowAddress(props.addresses[address.id])) {
                selected.name = address.name;
                selected.address = props.addresses[address.id];
                return false;
            }
            return true;
        });

        // eslint-disable-next-line react/state-in-constructor
        this.state = { selected };
    }

    isShowAddress(address) {
        return (
            !_.isEmpty(address) &&
            !(this.props.disableDifferentCountries && !_.isEqual(this.props.currentCountry, address.countryCode))
        );
    }

    handleCheck(addressName, address) {
        this.setState({
            selected: {
                name: addressName,
                address,
            },
        });
    }

    select() {
        this.props.onSelect(this.state.selected.address);
    }

    cancel() {
        this.props.onClose();
    }

    renderAddress = (addressId, addressName, address) => {
        return (
            <div key={addressName} className="modal-options-list">
                <div className="bluetxt">{addressName}</div>
                <RadioButton
                    checked={addressName === this.state.selected.name}
                    className="mt-base"
                    data-seleniumid={`select-profile-${addressId}-radio-input`}
                    id={`select-profile-${addressId}-radio`}
                    label={<OrdersRowAddress address={address} />}
                    onChange={() => this.handleCheck(addressName, address)}
                />
            </div>
        );
    };

    render() {
        return (
            <Modal
                className="Dialog"
                header={this.props.title}
                onClose={this.props.onClose}
                type="select-profile-address"
            >
                <div className="modal-body Dialog-Body" data-seleniumid="modal-body">
                    <DialogMessage html={this.props.text} type="address-doctor_no-suggestions" />
                    <div className="Dialog-SelectAddress">
                        {profileAddresses
                            .filter(address => this.isShowAddress(this.props.addresses[address.id]))
                            .map(address =>
                                this.renderAddress(address.id, address.name, this.props.addresses[address.id]),
                            )}
                    </div>
                    <div className="Dialog-BodyActions Dialog-BodyActions-Column">
                        <PrimaryButton data-seleniumid="select-profile-address-select-button" onClick={this.select}>
                            Select
                        </PrimaryButton>
                        <Button data-seleniumid="select-profile-address-cancel-button" onClick={this.cancel}>
                            Cancel
                        </Button>
                    </div>
                </div>
            </Modal>
        );
    }
}

export default OrdersDialogProfileAddresses;
